import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import { connect } from 'react-redux';
import {
  fetchRetailers as fetchRetailersAction,
  toggleMoreRetailers as toggleMoreRetailersAction,
} from '../modules';

const ProductRetailersContainer = ({
  childComponent: ChildComponent,
  ...props
}) => <ChildComponent {...props} />;

const mapStateToProps = ({
  content,
  locale,
  productRetailers = {},
  productSwatch = {},
}) => ({
  selectedSKU: productSwatch.selectedSKU,
  showMoreRetailersLabel: R.path(
    ['productDetails', 'showMoreRetailersLabel'],
    content
  ),
  showLessRetailersLabel: R.path(
    ['productDetails', 'showLessRetailersLabel'],
    content
  ),
  retailersHeadline: R.path(
    ['sectionHeadings', 'retailers', 'heading'],
    content
  ),
  buyButtonLabel: R.path(['productDetails', 'buttonText'], content),
  outOfStockLabel: R.path(['productDetails', 'outOfStockLabel'], content),
  retailers: R.prop('retailers', content),
  isOpen: R.prop('isOpen', productRetailers),
  skus: R.prop('skus', content),
  locale,
});

const mapDispatchToProps = (dispatch) => ({
  toggleMoreRetailers: () => dispatch(toggleMoreRetailersAction()),
  fetchRetailers: ({ skus, locale }) =>
    dispatch(fetchRetailersAction({ skus, locale })),
});

ProductRetailersContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductRetailersContainer);
